export const PERSON = {
  name:     "Mustafa Kadir Hasan",
  title:    "Senior Full-Stack Developer",
  subtitle: "React · Laravel · HRMS · ERP",
  location: "Addis Ababa, Ethiopia",
  email:    "muskehrandulo@gmail.com",
  github:   "https://github.com/Mustafa-Kadir",
  linkedin: "https://www.linkedin.com/in/mustafa-kadir-a422ab20b/",
  telegram: "https://t.me/Muskehran",
  whatsapp: "+251927505142",
  cv:       "/Mustefa.pdf",
};

export const STATS = [
  { value: 50,  suffix: "+", label: "Projects Delivered" },
  { value: 7,   suffix: "+", label: "Years Experience"   },
  { value: 100, suffix: "+", label: "Happy Clients"      },
  { value: 20,  suffix: "+", label: "Technologies"       },
];

export const SKILLS = {
  Frontend: [
    { name: "React.js",        pct: 95, icon: "⚛️" },
    { name: "JavaScript ES6+", pct: 92, icon: "🟨" },
    { name: "TypeScript",      pct: 80, icon: "🔷" },
    { name: "Tailwind CSS",    pct: 93, icon: "🎨" },
    { name: "Framer Motion",   pct: 78, icon: "✨" },
    { name: "HTML5 / CSS3",    pct: 95, icon: "🌐" },
  ],
  Backend: [
    { name: "Laravel",        pct: 92, icon: "🔴" },
    { name: "PHP",            pct: 90, icon: "🐘" },
     { name: "Python",         pct: 75, icon: "🐍" },
    { name: "REST APIs",      pct: 94, icon: "🔗" },
   
    { name: "System Arch.",   pct: 85, icon: "🏗️" },
  ],
  Database: [
    { name: "MySQL",             pct: 91, icon: "🗄️" },
     { name: "PostgreSQL",            pct: 82, icon: "🐘" },
    { name: "Database Design",   pct: 88, icon: "📐" },
    { name: "Redis",             pct: 72, icon: "🔴" },
    { name: "Query Optimisation",pct: 85, icon: "⚡" },
  ],
  Tools: [
    { name: "Git & GitHub", pct: 92, icon: "🐙" },
    { name: "Docker",       pct: 68, icon: "🐳" },
    { name: "Postman",      pct: 90, icon: "📬" },
    { name: "Figma",        pct: 75, icon: "🎯" },

  ],
  "AI & ERP": [
    { name: "AI Integration", pct: 82, icon: "🤖" },
    { name: "OpenAI API",     pct: 78, icon: "🧠" },
    { name: "HRMS Dev",       pct: 94, icon: "👔" },
    { name: "ERP Systems",    pct: 88, icon: "🔄" },
    { name: "Automation",     pct: 85, icon: "⚙️" },
  ],
};

export const EXPERIENCE = [
  {
    role:    "Senior Full-Stack Developer",
    company: "Tech Solutions Ethiopia",
    period:  "2022 — Present",
    type:    "Full-time",
    color:   "#8b5cf6",
    desc:    "Lead architect for enterprise HRMS and ERP systems serving 10+ corporate clients. Spearheaded OwnAttend — reducing HR processing time by 60%. Mentoring junior developers.",
    wins:    ["Built OwnAttend HRMS from scratch to production","Led CONE Enterprise Platform architecture","Reduced API response times by 40%"],
    tech:    ["React.js","Laravel","MySQL","Redis","Docker"],
  },
  {
    role:    "Full-Stack Developer",
    company: "Digital Agency Addis",
    period:  "2020 — 2022",
    type:    "Full-time",
    color:   "#22d3ee",
    desc:    "Developed and maintained 15+ client web applications. Introduced React.js, improving velocity by 35%. Delivered hotel and e-commerce platforms on time.",
    wins:    ["Delivered Hotel Management System on schedule","Introduced React.js into company stack","Managed 3 concurrent client projects"],
    tech:    ["React.js","Laravel","PHP","MySQL","Bootstrap"],
  },
  {
    role:    "IT Officer & Developer",
    company: "Nonprofit Organisation",
    period:  "2018 — 2020",
    type:    "Full-time",
    color:   "#6366f1",
    desc:    "Managed IT infrastructure while building the NGO management platform. Deployed a donor system tracking $2M+ in contributions entirely solo.",
    wins:    ["Built NGO Management System (200+ donors)","Managed complete IT infrastructure","Trained staff on digital workflows"],
    tech:    ["PHP","Laravel","MySQL","JavaScript","Bootstrap"],
  },
  {
    role:    "Freelance Developer",
    company: "Self-Employed",
    period:  "2017 — Present",
    type:    "Freelance",
    color:   "#a78bfa",
    desc:    "Delivering custom web solutions for local and international clients. Specialising in React frontends, Laravel backends, and complex database design.",
    wins:    ["50+ projects delivered globally","4.9 / 5 average client rating","100+ satisfied clients"],
    tech:    ["React.js","Laravel","PHP","MySQL","REST APIs"],
  },
];

export const PROJECTS = [
  {
    id:1, icon:"👥",
    title:"OwnAttend HRMS",
    category:"Enterprise",
    gradient:"from-violet-600 to-indigo-600",
    accent:"#8b5cf6",
    desc:"Comprehensive Human Resource Management System streamlining workforce operations for mid-to-large enterprises with real-time dashboards.",
    features:["GPS Based Attendance Management System","Payroll Engine","Leave Management","Asset Management","Budget Control","Performance Evaluation"],
    tech:["React.js","Laravel","MySQL","Redis","Tailwind"],
    stats:{Users:"500+",Uptime:"99.9%",Modules:"12"},
    featured:true,
  },
  {
    id:2, icon:"🏢",
    title:"CONE Enterprise",
    category:"ERP",
    gradient:"from-cyan-500 to-blue-600",
    accent:"#22d3ee",
    desc:"End-to-end ERP integrating finance, procurement, inventory and reporting into a unified platform for large organisations.",
    features:["Financial Management","Procurement","Inventory Control","Reporting Engine","Multi-branch","Role-based Access"],
    tech:["React.js","Laravel","MySQL","Chart.js"],
    stats:{Modules:"8",Reports:"50+",Users:"200+"},
    featured:true,
  },
  {
    id:3, icon:"🏨",
    title:"Hotel Management",
    category:"Hospitality",
    gradient:"from-amber-500 to-orange-600",
    accent:"#f59e0b",
    desc:"Full-stack property management system handling reservations, room operations, billing and guest experience in real time.",
    features:["Booking System","Room Management","Payment Gateway","Reports","Guest Profiles","Housekeeping"],
    tech:["React.js","Laravel","MySQL","Stripe","Tailwind"],
    stats:{Rooms:"∞",Bookings:"Live",Gateways:"3+"},
    featured:true,
  },
  {
    id:4, icon:"🛒",
    title:"E-Commerce Platform",
    category:"E-Commerce",
    gradient:"from-green-500 to-emerald-600",
    accent:"#10b981",
    desc:"Scalable e-commerce solution with product management, cart, secure checkout and multi-gateway payments.",
    features:["Product Variants","Shopping Cart","Secure Checkout","Order Tracking","Analytics","SEO"],
    tech:["React.js","Laravel","MySQL","Stripe","PayPal"],
    stats:{Products:"Unlimited",Speed:"< 2s",Gateways:"2+"},
    featured:false,
  },
  {
    id:5, icon:"📝",
    title:"CMS Website Builder",
    category:"CMS",
    gradient:"from-pink-500 to-rose-600",
    accent:"#ec4899",
    desc:"Drag-and-drop CMS with visual page building, user roles, SEO tools, and multi-language support.",
    features:["Drag & Drop","Dynamic Content","User Roles","SEO Toolkit","Media Manager","Multi-language"],
    tech:["React.js","Laravel","MySQL","TipTap","AWS S3"],
    stats:{Templates:"20+",Plugins:"15+",Languages:"Multi"},
    featured:false,
  },
  {
    id:6, icon:"🤝",
    title:"NGO Management",
    category:"Nonprofit",
    gradient:"from-teal-500 to-cyan-600",
    accent:"#14b8a6",
    desc:"Purpose-built platform for NGOs to track donors, manage programs, handle sponsorships and generate impact reports.",
    features:["Donor Management","Sponsorship","Programme Mgmt","Impact Reports","Volunteers","Transparency"],
    tech:["React.js","Laravel","MySQL","Chart.js","PDF Export"],
    stats:{Donors:"Tracked",Reports:"Auto",Impact:"Measured"},
    featured:false,
  },
];

export const SERVICES = [
  {
    icon:"🚀", title:"Full-Stack Development",
    border:"border-violet-500/20", bg:"from-violet-600/10 to-indigo-600/10",
    desc:"End-to-end web applications from schema design to polished UI, architected to scale.",
    items:["System Architecture","API Design","DB Optimisation","CI/CD Deployment"],
  },
  {
    icon:"⚛️", title:"React Development",
    border:"border-cyan-500/20", bg:"from-cyan-600/10 to-blue-600/10",
    desc:"Modern, performant React apps with exceptional UX — component libraries, state management, animations.",
    items:["Component Architecture","State Management","Performance Tuning","Animations"],
  },
  {
    icon:"🔴", title:"Laravel Development",
    border:"border-rose-500/20", bg:"from-rose-600/10 to-red-600/10",
    desc:"Robust backend APIs and web applications built with Laravel. Clean, tested and production-ready.",
    items:["RESTful APIs","Auth Systems","Queue Jobs","Laravel Packages"],
  },
  {
    icon:"👥", title:"HRMS Development",
    border:"border-amber-500/20", bg:"from-amber-600/10 to-orange-600/10",
    desc:"Custom HR systems tailored to your organisation — attendance, payroll and leaves automated.",
    items:["Attendance Tracking","Payroll Engine","Leave Management","Analytics"],
  },
  {
    icon:"🏢", title:"ERP Systems",
    border:"border-emerald-500/20", bg:"from-emerald-600/10 to-green-600/10",
    desc:"Enterprise resource planning systems unifying operations — finance, inventory, procurement.",
    items:["Multi-module Design","Role-based Access","Audit Trails","Custom Workflows"],
  },
  {
    icon:"🗄️", title:"Database Design",
    border:"border-purple-500/20", bg:"from-purple-600/10 to-pink-600/10",
    desc:"Optimised database architecture for performance at scale — query tuning, indexing, modelling.",
    items:["Schema Design","Query Optimisation","Migrations","Backup Strategy"],
  },
];

export const TESTIMONIALS = [
  {
    name:"Abebe Tadesse", role:"CEO, Addis Tech Solutions",
    init:"AT", grad:"from-violet-600 to-indigo-600", rating:5,
    text:"Mustafa built our entire HRMS from the ground up. The system handles 300+ employees flawlessly. His attention to detail and understanding of our business processes was exceptional — delivered on time and beyond expectations.",
  },
  {
    name:"Sara Mulugeta", role:"Operations Director, CONE Enterprise",
    init:"SM", grad:"from-cyan-600 to-blue-600", rating:5,
    text:"The ERP system Mustafa developed transformed how we run our business. What used to take days in manual processes now runs in minutes. The React frontend is fast, intuitive and our staff adopted it immediately.",
  },
  {
    name:"Michael Bekele", role:"GM, Addis Hospitality Group",
    init:"MB", grad:"from-emerald-600 to-teal-600", rating:5,
    text:"Our hotel management system is the backbone of our operations. Mustafa understood hospitality workflows deeply and translated that into software. Guest check-in time dropped by 70%. Highly recommended.",
  },
  {
    name:"Yohannes Desta", role:"IT Manager, Sunrise NGO",
    init:"YD", grad:"from-amber-600 to-orange-600", rating:5,
    text:"Managing donor data was a nightmare before Mustafa built our platform. Now we track every contribution, generate reports in seconds and our donors love the transparency. Professional, responsive and brilliant.",
  },
];
